import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { Button } from '@shared/components';

const { Text } = Typography;

interface Props {
  onClose: () => void;
}

const HealthCareClustersModal = ({ onClose }: Props) => {
  const { t } = useTranslation();
  return (
    <div>
      <Text className="mb-2 block text-center text-base font-bold">{`Healthcare clusters' apps`}</Text>
      <ul className="mx-4 mb-6 list-disc">
        <li className="text-theme-700">NHG: NHG Cares</li>
        <li className="text-theme-700">NUHS App</li>
        <li className="text-theme-700">SingHealth: Health Buddy</li>
      </ul>
      <Button className="w-full" onClick={onClose}>
        {t('optOut.okBtn')}
      </Button>
    </div>
  );
};

export default HealthCareClustersModal;
